import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 2a7.5 7.5 0 0 1 5.806 12.245l5.224 5.225a.75.75 0 0 1-1.06 1.06l-5.225-5.224A7.5 7.5 0 1 1 9.5 2m0 1.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12",
    clipRule: "evenodd"
  }));
}
var IcSearch = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearch));

export { IcSearch as I };
